var _defs, _path, _path2, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconos32PxFase2B1Generic12({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#39b54a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICONOS-32PX-FASE-2b.1-GENERIC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.64,10.85V8.75a.27.27,0,0,0-.27-.27H14a.27.27,0,0,0-.27.27v2.1a1.49,1.49,0,0,0-1,1.23V22.6a.85.85,0,0,0,.58.8v1.22a.27.27,0,0,0,.27.27H18.8a.27.27,0,0,0,.27-.27V23.4a.85.85,0,0,0,.58-.8V12.08A1.49,1.49,0,0,0,18.64,10.85Zm.48,11.75a.31.31,0,0,1-.31.31H13.59a.31.31,0,0,1-.31-.31V12.08c0-.42.59-.75.75-.75a.27.27,0,0,0,.27-.27V9H18.1v2.05a.27.27,0,0,0,.27.27c.15,0,.75.33.75.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.64,9.2h-2.9a.27.27,0,0,0-.26.32L14.77,11a.27.27,0,0,0,.26.22h2.32a.27.27,0,0,0,.26-.22l.29-1.45a.27.27,0,0,0-.26-.32Zm-.33.54-.18.91H15.26l-.18-.91Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.19,
    y: 12.34,
    width: 5.93,
    height: 1.93
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.19,
    y: 14.87,
    width: 5.93,
    height: 1.93
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.19,
    y: 17.4,
    width: 5.93,
    height: 1.93
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.19,
    y: 19.93,
    width: 5.93,
    height: 1.93
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconos32PxFase2B1Generic12);
export default __webpack_public_path__ + "static/media/ICONOS-32PX-FASE-2b.1-GENERIC-12.2e05f7baee94322e5e13add023c700d7.svg";
export { ForwardRef as ReactComponent };